import FooterLinks from "./footer-links";
import MainFooter from "./main-footer";
import FooterOrganizations from "./footer-organizations";
import Values from "./values";
import classNames from "classnames";
import FooterSubscriptionBanner from "./footer-subscription-banner";
import { useLayoutContext } from "@context/layout";
import { productRoutes } from "@utils/course";
import { useRouter } from "next/router";

interface Props {
  showAppFooter?: boolean;
  showOrganizationFooter?: boolean;
  showLinkFooter?: boolean;
  showMainFooter?: boolean;
  showValuesFooter?: boolean;
  showButtonOrganizationFooter?: boolean;
  showHomeAppFooter?: boolean;
  coloredMainFooterBg?: boolean;
}

const Footer: React.FC<Props> = ({
  showAppFooter = true,
  showOrganizationFooter = false,
  showLinkFooter = true,
  showMainFooter = true,
  showValuesFooter = true,
  showButtonOrganizationFooter = true,
  showHomeAppFooter = false,
  coloredMainFooterBg = false,
}) => {
  const { subscriptionData } = useLayoutContext();
  const { pathname } = useRouter();

  const subscriptionBannerCondition =
    !subscriptionData?.is_active &&
    !productRoutes.includes(pathname) &&
    Boolean(showValuesFooter || showLinkFooter);

  const isSubscriptionPage = pathname.includes("/subscription");

  return (
    <footer
      className={classNames(
        "relative bg-white",
        showAppFooter ||
          showOrganizationFooter ||
          showLinkFooter ||
          showMainFooter ||
          showValuesFooter ||
          showHomeAppFooter
          ? "pt-12"
          : "",
        isSubscriptionPage ? "fds-sm:pb-0 pb-36" : "pb-[68px] md:pb-0"
      )}
    >
      {showOrganizationFooter && (
        <FooterOrganizations
          showButtonOrganizationFooter={showButtonOrganizationFooter}
        />
      )}
      {showValuesFooter ? <Values /> : null}
      {showLinkFooter && <FooterLinks />}
      {subscriptionBannerCondition && <FooterSubscriptionBanner />}
      {showMainFooter && (
        <MainFooter
          showHomeAppFooter={showHomeAppFooter}
          coloredMainFooterBg={coloredMainFooterBg}
        />
      )}
    </footer>
  );
};

export default Footer;
